    $(function() {
    var body = $("body");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            body.removeClass('scroll-end').addClass("scroll-start-animation");
        } else {
            body.removeClass("scroll-start-animation").addClass('scroll-end');
        }
    });
});

var lastScroll = 0;
var isScrolled = false;
window.addEventListener("scroll", function () {
  var topHeader = document.querySelector("body");
  var currentScroll =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  var scrollDirection = currentScroll < lastScroll;
  var shouldToggle = isScrolled && scrollDirection;
  isScrolled = currentScroll > 100;
  topHeader.classList.toggle("scroll-start", shouldToggle);
  lastScroll = currentScroll;
});   




// // add desc-blue class in product description
// document.addEventListener('DOMContentLoaded', function() {
//     var listItems = document.querySelectorAll('#x-main-desc ul li');

//     listItems.forEach(function(li) {
//         if (li.textContent.includes('Condition:')) {
//             li.classList.add('desc-blue');
//         }
//     });
// });


  document.addEventListener('DOMContentLoaded', function() {
    var listItems = document.querySelectorAll('.description.user-content ul li');
    listItems.forEach(function(li) {
      if (li.textContent.includes('Condition')) {
        li.classList.add('desc-blue');
      }
    });
  });


 function updateCounter() {
    var currentCount = parseFloat(document.getElementById('co2-counter').innerText.replace(/,/g, ''));
   
    var newCount = currentCount + 0.13;
    
    document.getElementById('co2-counter').innerText = newCount.toLocaleString(); 
    
    setTimeout(updateCounter, 1000); // Update every second
}

updateCounter();

      
      function updateEarthCounter() {
    var currentCount = parseFloat(document.getElementById('earth-counter').innerText.replace(/,/g, ''));
    var newCount = currentCount + 25;
    document.getElementById('earth-counter').innerText = newCount.toLocaleString();
}

updateEarthCounter();
setInterval(updateEarthCounter, 1000); // Update every second



